import { executeRequest, JFSRequest } from '@jfs/network'
import { convertToCaps } from '../utils'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data?.map((item, index) => {
    return {
      id: `${index}`,
      value: item?.identificationNumber ?? '',
    }
  })
}

const getGroupIdsReq = (tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getGroupIds),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {}
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getGroupIdsReq }
